var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRwRwanda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_22964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#20603D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V33.75H60V0Z",
    fill: "#FAD201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V22.5H60V0Z",
    fill: "#00A1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83746 11.7563L9.86249 12.0501L5.08746 13.6376L10.0125 12.6189L5.80622 15.3814L10.3062 13.1189L6.96872 16.8876L10.725 13.5439L8.46248 18.0439L11.2312 13.8376L10.2187 18.7564L11.8 13.9876L12.0937 19.0126L12.1562 11.6938L4.83746 11.7563Z",
    fill: "#E5BE01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0935 13.9003C10.9096 13.9003 9.94978 12.9405 9.94978 11.7566C9.94978 10.5726 10.9096 9.61279 12.0935 9.61279C13.2775 9.61279 14.2373 10.5726 14.2373 11.7566C14.2373 12.9405 13.2775 13.9003 12.0935 13.9003Z",
    fill: "#E5BE01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0937 9.71885C13.219 9.71885 14.1312 10.6311 14.1312 11.7564C14.1312 12.8816 13.219 13.7939 12.0937 13.7939C10.9685 13.7939 10.0562 12.8816 10.0562 11.7564C10.0562 10.6311 10.9685 9.71885 12.0937 9.71885ZM14.3438 11.7564C14.3438 10.5137 13.3364 9.50635 12.0937 9.50635C10.8511 9.50635 9.84373 10.5137 9.84373 11.7564C9.84373 12.999 10.8511 14.0064 12.0937 14.0064C13.3364 14.0064 14.3438 12.999 14.3438 11.7564Z",
    fill: "#00A1DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_22964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwRwanda);
export default __webpack_public_path__ + "static/media/rw Rwanda.4ee5cff7c4050baabb7890f26e7ac624.svg";
export { ForwardRef as ReactComponent };